import React from 'react';
import {
  Box,
  Modal,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const PreviewPay = ({ open, close, pay }) => {
  return (
    <Modal open={open} onClose={close}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
          height: "80%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6">Preview Pay</Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>
        {pay && (
          <img
            src={pay.imagen}
            alt={pay.titulo}
            style={{
              width: "100%",
              maxHeight: "70%",
              objectFit: "contain",
              marginTop: "15px",
            }}
          />
        )}
      </Box>
    </Modal>
  );
};
